import styled from "styled-components";
import {
  Attribute,
  AttributeGroup,
  AttributeProperty,
  ComponentProps,
  ConfigContext,
  ContainerAttributes,
} from "react-builder";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

@AttributeGroup({ title: "SearchInput", blockName: "SearchInput" })
export class SearchInputAttributes extends Attribute {
  @AttributeProperty({ type: "String" })
  baseUrl = "";

  @AttributeProperty({ type: "String" })
  searchValue = "";

  @AttributeProperty({ type: "String" })
  placeholder = "Search";

  @AttributeProperty({ type: "Object", cssTarget: "" })
  container: ContainerAttributes = new ContainerAttributes();

  @AttributeProperty({
    title: "Input",
    type: "Object",
    cssTarget: " .form-group input.search-input",
  })
  input: ContainerAttributes = new ContainerAttributes();
}

const SearchInputTheme = styled.div(
  (props: { attributes: SearchInputAttributes }) => `

    ${props.attributes.toCSS()}

`
);

function SearchInput(props: ComponentProps<SearchInputAttributes>) {
  const content = useContext(ConfigContext);
  const searchValue = props.attributes.searchValue
    ? content.getContent(props.attributes.searchValue)
    : "";
  const [searchTerm, setSearchTerm] = useState(searchValue);
  const history = useHistory();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (searchTerm.trim() !== "") {
      history.push(`${props.attributes.baseUrl}/${encodeURIComponent(searchTerm.trim())}`);
    }
  };
  return (
    <SearchInputTheme {...props} attributes={props.attributes}>
      <form onSubmit={handleSubmit} className="form-group">
        <input
          className="search-input"
          type="text"
          value={searchTerm}
          onChange={handleInputChange}
          placeholder={props.attributes.placeholder}
        />
        {props.children}
      </form>
    </SearchInputTheme>
  );
}

SearchInput.prototype.Props = SearchInputAttributes;

export default SearchInput;
